<!-- 兑换记录 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="top">
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          size="small"
        >
          <el-form-item label="所属门店">
            <el-select
              v-model="formInline.room_id"
              placeholder="请选择门店"
              clearable
              @change="getOrderList"
            >
              <el-option
                v-for="item in shopLists"
                :key="item.value"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否使用联盟积分">
            <el-select
              v-model="formInline.use_alliance_point"
              placeholder="选择"
              clearable
              @change="getOrderList"
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select
              v-model="formInline.order_type"
              placeholder="选择"
              clearable
              @change="getOrderList"
            >
              <el-option label="积分兑换" value="1"></el-option>
              <el-option label="商城订单" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上下架状态">
            <el-select
              v-model="formInline.status"
              placeholder="选择"
              clearable
              @change="getOrderList"
            >
              <el-option label="上架" value="1"></el-option>
              <el-option label="下架" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div style="height: 40px;">
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          size="small"
        >
          <el-form-item label="开始时间">
            <!-- <el-date-picker
              v-model="date"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker> -->

            <el-date-picker
              v-model="date1"
              type="datetime"
              placeholder="选择日期时间"
              align="right"
              :picker-options="pickerOptions"
              @change="Date1"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              v-model="date2"
              type="datetime"
              placeholder="选择日期时间"
              align="right"
              :picker-options="pickerOptions"
              @change="Date2"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              placeholder="会员手机号"
              v-model="formInline.mobile"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="cxlist">查询</el-button>
            <el-button type="primary" @click="exportOrder">导出订单</el-button>
            <el-button
              type="danger"
              @click="handleBatchDelete"
              :disabled="selectedIds.length === 0"
              >批量删除</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="cont">
        <div class="table">
          <div class="title flex padding">
            <div style="min-width: 50px;">
              <el-checkbox
                v-model="selectAll"
                @change="handleSelectAll"
              ></el-checkbox>
            </div>
            <div class="product">编号/商品</div>
            <div class="uid">会员</div>
            <div class="pay">支付</div>
            <div class="consume">消耗</div>
            <div class="consume">订单时间</div>
            <div class="status" style="width: 100px !important;">状态</div>
            <div style="min-width: 100px;width: 650px !important;">
              订单来源
            </div>
            <div style="min-width: 100px;width: 750px !important;">
              核销方式
            </div>
            <div style="min-width: 140px;width: 650px !important;">
              核销时间
            </div>
            <div style="min-width: 150px;width: 400px !important;">
              核销人员
            </div>
            <div style="min-width: 160px;width: 250px !important;">操作</div>
          </div>
          <div class="list">
            <div class="box" v-for="(item, index) in tableData" :key="index">
              <div class="bianhao padding">
                <div class="left">订单号：{{ item.order_sn }}</div>
                <div class="right"></div>
              </div>

              <div
                class="detail flex padding"
                v-if="item.goods != null && item.goods"
              >
                <div style="min-width: 50px;">
                  <el-checkbox
                    v-model="item.checked"
                    @change="handleSelectItem"
                  ></el-checkbox>
                </div>
                <div class="product flex">
                  <img
                    :src="item.goods.logo"
                    alt
                    style="width: 80px; margin-right: 15px"
                  />
                  <div>
                    <div>
                      {{ item.goods.title }}
                      <span style="color: red;">x</span>
                      {{ item.num }}
                    </div>
                    <div v-if="item.goods.alliance_goods != 0">
                      <el-tag size="small">联盟商品</el-tag>
                    </div>
                  </div>
                </div>

                <div class="uid" v-if="item.info != null">
                  <!-- <img :src="item.goods.logo" alt="" style="width: 60px"> -->
                  <div>{{ item.info.username }}</div>
                </div>
                <div class="uid" v-else>
                  暂无购买人信息
                  <!-- <img :src="item.goods.logo" alt="" style="width: 60px"> -->
                </div>
                <div class="pay" v-if="item.buy_method !== 1">
                  <div>支付{{ item.total_money }}</div>
                  <!-- <div>无需用费</div> -->
                </div>
                <div class="pay" v-else>
                  <div>无需支付</div>
                  <div>无需用费</div>
                </div>
                <div class="consume">{{ item.total_credit }}积分</div>
                <div class="consume">{{ item.create_time }}</div>
                <div class="status" style="width: 100px !important;">
                  <el-button
                    size="mini"
                    type="success"
                    v-if="item.status == 1"
                    :disabled="true"
                    >已核销</el-button
                  >
                  <el-button
                    size="mini"
                    type="success"
                    v-else
                    @click="pop(item.status, item.id)"
                    >未核销</el-button
                  >
                </div>
                <div style="min-width: 100px;width: 650px !important;">
                  <span
                    v-text="
                      item.order_source == 1
                        ? '员工端'
                        : item.order_source == 2
                        ? 'pc端'
                        : '用户端'
                    "
                  ></span>
                </div>
                <div style="min-width: 100px;width: 4050px !important;">
                  <span
                    v-text="
                      item.consume_type == 1
                        ? '员工端'
                        : item.consume_type == 2
                        ? '扫码设备'
                        : item.consume_type == 3
                        ? 'PC端'
                        : item.consume_type == 4
                        ? '会员码'
                        : item.consume_type == 5
                        ? '自动核销'
                        : ''
                    "
                  ></span>
                </div>
                <div style="min-width: 10px;width: 51050px !important;">
                  <span v-if="item.status == 1 && item.consume_time !== 0">
                    {{ item.consume_time | dataFormat }}
                  </span>
                </div>
                <div style="min-width: 160px;width: 51050px !important;">
                  <span
                    v-if="
                      item.status == 1 &&
                        item.consume_type !== 5 &&
                        item.consume_type !== 0 &&
                        item.emp_info !== null
                    "
                  >
                    {{
                      item.emp_info.realname + "(" + item.emp_info.mobile + ")"
                    }}
                  </span>
                </div>
                <div style="min-width: 160px;width: 350px !important;">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="handleDelete(item.id)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, jumper"
            :total="total_num"
          ></el-pagination>
        </div>
      </div>
    </div>
    <shipments
      :showDialog="showDialog"
      :formData="formData"
      @close="close"
    ></shipments>
    <!-- 核销 -->
    <el-dialog :visible.sync="verifiyFormVisible"></el-dialog>
  </div>
</template>

<script>
import { selectStoreList } from "@/api/storeManage";
import { exportMethods } from "@/api/vip";
import shipments from "./shipments.vue";
import { orderDelete, orderList, orderVerifiy } from "@/api/integralMall";
import { mapGetters } from "vuex";

export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["app_id", "token"]),
    getstart_time: function() {
      return this.formInline.start_time;
    },
    getend_time: function() {
      return this.formInline.end_time;
    }
  },
  data() {
    return {
      selectAll: false,
      selectedIds: [],
      selectedIdsMap: {}, // 用于跨页保存选中状态
      emp: true,
      end_time: true,
      date1: "",
      date2: "",
      tableData: [
        {
          order_sn: "",
          status: "",
          num: "",
          id: "",
          goods: {
            title: "",
            logo: "",
            alliance_goods: ""
          },
          info: {
            username: ""
          },
          create_time: ""
        }
      ],
      page: "1",
      total_num: 0,
      screenInput: "",
      data: [],
      showDialog: false,
      formData: {
        address: {
          name: "",
          mobile: "",
          area_name: "",
          address: ""
        }
      },
      formInline: {
        use_alliance_point: "",
        room_id: "",
        order_type: "",
        status: "",
        start_time: "",
        end_time: ""
      },
      shopLists: [],
      verifiyFormVisible: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          },
          {
            text: "三个月前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 3 * 30);
              picker.$emit("pick", date);
            }
          }
        ]
      }
    };
  },
  watch: {},
  components: {
    shipments
  },
  created() {
    this.getOrderList();
    this.getShopList(); //门店列表
  },
  methods: {
    getShopList() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      selectStoreList(data).then(res => {
        console.log("门店下拉列表", res);
        this.shopLists = res.data;
      });
    },
    // 发货
    deliverGoods(item) {
      this.showDialog = true;
      this.formData = item;
    },
    close() {
      this.showDialog = false;
      this.reload();
    },
    Date1(val) {
      console.log(val);
      if (val == null) {
        this.formInline.start_time = "";
      } else {
        this.formInline.start_time = val.getTime();
      }
    },
    Date2(val) {
      console.log(val);
      if (val == null) {
        this.formInline.end_time = "";
      } else {
        this.formInline.end_time = val.getTime();
      }
    },
    // 获取列表
    cxlist() {
      // 查询时清空选中状态
      this.selectedIdsMap = {};
      this.selectedIds = [];
      this.selectAll = false;

      if (this.formInline.start_time && this.formInline.end_time) {
        console.log(this.formInline.start_time, this.formInline.end_time);
        let res = this.formInline.start_time - this.formInline.end_time;
        if (res > 0) {
          this.$message.error("请确定选择结束日期不能位于开始日期之前");
          this.formInline.start_time = "";
          this.formInline.end_time = "";
          this.date1 = "";
          this.date2 = "";
        } else {
          this.getOrderList();
        }
      } else {
        this.getOrderList();
      }
    },
    getOrderList() {
      let data = {
        app_id: this.app_id,
        page: this.page,
        room_id: this.formInline.room_id,
        use_alliance_point: this.formInline.use_alliance_point,
        status: this.formInline.status,
        start_time: this.formInline.start_time,
        end_time: this.formInline.end_time,
        order_type: this.formInline.order_type
      };
      if (this.formInline.mobile) {
        data.mobile = this.formInline.mobile;
      }
      orderList(data).then(res => {
        console.log("订单列表", res);
        if (res.code == 200) {
          var data = res.data.result;
          // data.consume_time = time(res.data.result.consume_time)
          for (var k in data) {
            if (data[k].goods == null) {
              let obj = {};
              obj.logo = "";
              obj.title = "";
              data[k].goods = obj;
            }
            // 恢复选中状态
            data[k].checked = this.selectedIdsMap[data[k].id] || false;
          }
          data.forEach(item => {
            if (!item.emp_info || item.emp_info.length == 0) {
              item.emp_info = null;
            }
          });
          console.log(data);
          this.tableData = data;
          this.total_num = res.data.total_num;
          // 更新全选状态和选中ID列表
          this.updateSelectedIds();
          this.selectAll =
            this.tableData.length > 0 &&
            this.tableData.every(item => item.checked);
          if (data.length <= 0) {
            this.$message.info("没有更多了");
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 核销
    pop(status, index) {
      if (status == 1) {
        this.$message("已经完成核销！");
      } else {
        this.$prompt("请输入核销码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(({ value }) => {
            console.log("填的值", value);
            let data = {
              token: this.token,
              app_id: this.app_id,
              id: index,
              cancel_code: value,
              consume_type: 3
            };
            orderVerifiy(data).then(res => {
              console.log("核销订单", res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.getOrderList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入"
            });
          });
      }
    },
    // 全选/取消全选
    handleSelectAll(val) {
      this.tableData.forEach(item => {
        item.checked = val;
        // 同步到跨页选中状态
        if (val) {
          this.selectedIdsMap[item.id] = true;
        } else {
          delete this.selectedIdsMap[item.id];
        }
      });
      this.updateSelectedIds();
    },
    // 单选
    handleSelectItem() {
      // 同步到跨页选中状态
      this.tableData.forEach(item => {
        if (item.checked) {
          this.selectedIdsMap[item.id] = true;
        } else {
          delete this.selectedIdsMap[item.id];
        }
      });
      this.updateSelectedIds();
      this.selectAll =
        this.tableData.length > 0 && this.tableData.every(item => item.checked);
    },
    // 更新选中的ID列表
    updateSelectedIds() {
      this.selectedIds = Object.keys(this.selectedIdsMap).map(id =>
        parseInt(id)
      );
    },
    // 批量删除
    handleBatchDelete() {
      if (this.selectedIds.length === 0) {
        this.$message.warning("请先选择要删除的订单");
        return;
      }
      this.$confirm(
        `此操作将永久删除选中的${this.selectedIds.length}个订单，是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          const data = await orderDelete({
            id: this.selectedIds.join(",")
          });
          console.log(data);
          if (data.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功！"
            });
            // 删除成功后清空选中状态
            this.selectedIdsMap = {};
            this.selectedIds = [];
            this.selectAll = false;
            this.getOrderList();
          } else {
            this.$message({
              type: "error",
              message: data.msg || "删除失败"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 删除订单
    handleDelete(id) {
      console.log("--------");
      console.log(id);
      this.$confirm("此操作永久删除该商品，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const data = await orderDelete({
            id: id
          });
          console.log(data);
          if (data.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功！"
            });
            this.getOrderList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getOrderList();
    },
    exportOrder() {
      if (this.formInline.start_time && this.formInline.end_time) {
        console.log(this.formInline.start_time);
        this.$confirm("确定要导出吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let data = {
              Api: "creditshop/agent.Creditshop_Goods_Order/export",
              app_id: this.app_id,
              params: [
                { name: "token", value: this.token },
                { name: "page", value: this.page },
                { name: "room_id", value: this.formInline.room_id },
                { name: "status", value: this.formInline.status },
                {
                  name: "use_alliance_point",
                  value: this.formInline.use_alliance_point
                },
                { name: "order_type", value: this.formInline.order_type },
                {
                  name: "start_time",
                  value: String(this.formInline.start_time).substring(0, 10)
                },
                {
                  name: "end_time",
                  value: String(this.formInline.end_time).substring(0, 10)
                },
                { name: "mobile", value: this.formInline.mobile || "" }
              ]
            };
            exportMethods(data);
          })
          .catch(() => {
            this.formInline.start_time = "";
            this.formInline.end_time = "";
          });
      } else {
        this.$message({
          type: "error",
          message: "请先选择日期(三个月以内)"
        });
        this.formInline.start_time = "";
        this.formInline.end_time = "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../../../public/style/_interfacePublic";
.flex {
  display: flex;
  align-items: center;
}
.padding {
  padding: 20px;
}
.content {
  width: 100%;

  .bodycontent {
    width: 100%;
    height: 100%;
    min-width: 1200px;

    .top {
      margin: 5px 0;
      height: 35px;
      // padding-top: 20px;
      // box-sizing: border-box;
    }
    .cont {
      width: 100%;
      min-width: auto;
      height: calc(100% - 80px);
      display: flex;
      flex-direction: column;
      .table {
        width: 100%;
        flex: 1;
        border: 1px solid #eeeeee;
        overflow-y: scroll;
        overflow-y: overlay;
        .title {
          height: 48px;
          line-height: 48px;
          background: rgba(250, 250, 250, 1);
          color: #000;
          font-weight: 500;
          min-width: auto;
        }
        .list {
          min-width: auto;
          .box {
            border: 1px solid #f1f1f1;
            .bianhao {
              height: 34px;
              display: flex;
              align-items: center;
              border-bottom: 1px dashed #f1f1f1;
              // background: #f5f7fa;
            }
          }
        }
        .product {
          min-width: 200px;
        }
        .message {
          min-width: 100px;
        }
        .uid {
          min-width: 140px;
        }
        .pay {
          min-width: 140px;
          padding: 0 24px;
        }
        .consume {
          min-width: 160px;
        }
        .option {
          min-width: 180px;
        }
        .status {
          flex: 1;
          min-width: 100px;
        }
      }
      .page {
        height: 50px;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
